// TODO: Assessment remote cleanup, delete this file. See "Cleanup" in docs/RemoteModules.md
import {
  BlankValue,
  CheckboxValue,
  CommonValue,
} from './reservationSettingsColumnValues.type';

export const templateTypes = [
  'entrance-list',
  'room-specific',
  'invigilator-attendance',
] as const;
export type TemplateType = (typeof templateTypes)[number];

export const pageOrientations = ['portrait', 'landscape'] as const;
type PageOrientation = (typeof pageOrientations)[number];

export const sortDirections = ['asc', 'desc'] as const;
type SortDirection = (typeof sortDirections)[number];

export const pageBreaks = [
  'capacity-reservation',
  'exam-reservation',
  'exam-reservation-with-header',
  'none',
] as const;
export type PageBreak = (typeof pageBreaks)[number];
export const defaultPageBreak: PageBreak = 'capacity-reservation';

export type ExamV3ExportTemplate = {
  _id?: string;
  id?: string;
  name: string;
  title: string;
  description?: string;
  templateType: TemplateType;
  timezone?: string;
  pageOrientation: PageOrientation;
  dateFormat?: string;
  mainHeader?: Array<CommonValue>;
  mainHeaderNoOfColumns?: number;
  pageBreak?: PageBreak;
  seatingList: {
    examRange?: {
      sort: SortDirection;
      sortBy: number | string;
      columns: Array<CommonValue | BlankValue | CheckboxValue>;
    };
    studentList: {
      sort: SortDirection;
      sortBy: number | string;
      title: CommonValue;
      header: Array<CommonValue | BlankValue>;
      headerNoOfColumns?: number;
      columns: Array<CommonValue | BlankValue | CheckboxValue>;
    };
  };
  createdBy: string;
  updatedBy?: string;
  deletedBy?: string;
  createdAt: Date;
  updatedAt?: Date;
  deletedAt?: Date;
};

export type ExamV3ExportTemplates = Pick<
  ExamV3ExportTemplate,
  | '_id'
  | 'name'
  | 'description'
  | 'createdAt'
  | 'updatedAt'
  | 'createdBy'
  | 'updatedBy'
>;
